export const parsePayerCents = value => {
  if (typeof value === 'number') return Math.round(value * 100);
  const source = String(value || '').replace(/[^\d,.-]/g, '');
  if (!source) return 0;
  const normalized = source.includes(',')
    ? source.replaceAll('.', '').replace(',', '.')
    : source;
  return Math.round(Number(normalized) * 100) || 0;
};

export const formatPayerCents = cents =>
  `R$ ${new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.max(cents, 0) / 100)}`;

export const emptyPayerRow = () => ({
  property_transaction_party_id: '',
  valor_pagamento: '',
});

export const totalPayerCents = rows =>
  rows.reduce((total, row) => total + parsePayerCents(row.valor_pagamento), 0);

export const distributePayerRows = ({ rows, installmentCents }) => {
  const divisor = rows.length || 1;
  const base = Math.floor(installmentCents / divisor);
  const remainder = installmentCents - base * divisor;
  return rows.map((row, index) => ({
    ...row,
    valor_pagamento: formatPayerCents(
      base + (index === divisor - 1 ? remainder : 0)
    ),
  }));
};

export const resizePayerRows = ({
  rows,
  count,
  maxCount,
  installmentCents,
}) => {
  const nextCount = Math.max(1, Math.min(Number(count) || 1, maxCount));
  const resized = rows.slice(0, nextCount);
  while (resized.length < nextCount) resized.push(emptyPayerRow());
  return {
    count: nextCount,
    rows: distributePayerRows({ rows: resized, installmentCents }),
  };
};

export const payerFormFromInstallment = installment => {
  const options = installment?.compradores_vendedores || [];
  const current = installment?.parcela?.responsaveis_pagamento || [];
  const installmentCents =
    installment?.parcela?.valor_parcela?.amount_cents || 0;
  const count = Math.max(1, Math.min(current.length || 1, options.length || 1));
  const rows = current.length
    ? current.map(row => ({
        property_transaction_party_id:
          row.responsavel_id || row.usuario_id || '',
        valor_pagamento: formatPayerCents(
          parsePayerCents(row.valor_pagamento?.amount)
        ),
      }))
    : distributePayerRows({ rows: [emptyPayerRow()], installmentCents });
  return { count, rows };
};

export const validPayerRows = ({ rows, optionsLength, installmentCents }) =>
  optionsLength > 0 &&
  rows.length > 0 &&
  rows.every(
    row =>
      row.property_transaction_party_id &&
      parsePayerCents(row.valor_pagamento) > 0
  ) &&
  totalPayerCents(rows) === installmentCents;

export const payerRowsPayload = rows =>
  rows.map(row => ({
    property_transaction_party_id: Number(row.property_transaction_party_id),
    valor_pagamento: row.valor_pagamento,
  }));
